import React from 'react'
import {Constructor} from 'ytil'
import {BeWizrLibraryItem} from '~/models'

const registry: Map<Constructor<BeWizrLibraryItem>, React.ComponentType<BeWizrLibraryItemProps<any>>> = new Map()

export function getLibraryItemComponent(item: BeWizrLibraryItem) {
  for (const [Model, Component] of registry) {
    if (item instanceof Model) {
      return Component
    }
  }

  return null
}

export function register<M extends BeWizrLibraryItem>(Model: Constructor<M>, component: React.ComponentType<BeWizrLibraryItemProps<M>>) {
  registry.set(Model, component)
}

export interface BeWizrLibraryItemProps<M> {
  item: M
}